export const GET_JURISDICTIONS_REQUEST = 'GET_JURISDICTIONS_REQUEST';
export const GET_JURISDICTIONS_SUCCESS = 'GET_JURISDICTIONS_SUCCESS';
export const GET_JURISDICTIONS_FAILED = 'GET_JURISDICTIONS_FAILED';

export const DELETE_JURISDICTION_REQUEST = 'DELETE_JURISDICTION_REQUEST';
export const DELETE_JURISDICTION_SUCCESS = 'DELETE_JURISDICTION_SUCCESS';
export const DELETE_JURISDICTION_FAILED = 'DELETE_JURISDICTION_FAILED';
